import { useEffect, useState } from 'react';
import { useApi } from 'lib/contexts/ApplicationState';

interface Props {
  referredBy: string;
}

export const ReferralSpeech = ({ referredBy }: Props) => {
  const API = useApi();
  const [name, setName] = useState('Your friend');
  const [avatarUrl, setAvatarUrl] = useState('/avatars/avatar-2.png');
  const [isLoaded, setIsLoaded] = useState(false);

  const speechBubble = (
    <div className="hidden md:block absolute left-0 w-4 overflow-hidden transform -translate-x-4">
      <div className="h-16  bg-teal -rotate-45 transform origin-top-right" />
    </div>
  );

  useEffect(() => {
    const getReferredBy = async () => {
      if (!referredBy) {
        setIsLoaded(true);
        return;
      }

      const user = await API.getUserByReferralCode(referredBy);
      if (user) {
        setName(user.name);
        setAvatarUrl(user.avatarUrl);
      }
      setIsLoaded(true);
    };

    getReferredBy();
  }, [referredBy]);

  if (!isLoaded) return null;

  return (
    <div className="bg-hintgray p-4 rounded-lg max-w-2xl">
      <h1 className="text-2xl font-bold text-center" data-testid="invite">
        {name}
        {' '}
        invited you to try out Gondola!
      </h1>
      <div className="flex flex-col md:flex-row p-4">
        <div className="md:w-1/4 mb-2 flex items-center md:items-end">
          <img className="m-auto w-1/2 md:w-3/4 rounded-full" src={avatarUrl} alt={name} />
        </div>
        <div className="md:w-3/4 md:p-4">
          <div className="text-xl text-white">
            <div className="relative bg-teal rounded-2xl py-4 px-6 mb-4">
              {speechBubble}
              <div className="absolute left-0 bottom-0  bg-teal border-t-8 border-t-transparent transform -translate-x-2 translate-y-1" />
              Hey, let&#39;s get your content on Gondola!
              {' '}
              <span role="img" aria-label="Fist emojis facing left and right">🤜🤛</span>
            </div>
            <div className="relative bg-teal rounded-2xl py-4 px-6">
              {speechBubble}
              Gondola gives you the power to collect, organize, and track social media
              posts and give credit to the great minds that make them.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
